"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectedConnector = exports.UserRejectedRequestError = exports.NoTronWebProviderError = void 0;
const abstract_connector_1 = require("@web3-react/abstract-connector");
class NoTronWebProviderError extends Error {
    constructor() {
        super();
        this.name = this.constructor.name;
        this.message = 'No tronWeb provider was found on window.tronWeb.';
    }
}
exports.NoTronWebProviderError = NoTronWebProviderError;
class UserRejectedRequestError extends Error {
    constructor() {
        super();
        this.name = this.constructor.name;
        this.message = 'The user rejected the request.';
    }
}
exports.UserRejectedRequestError = UserRejectedRequestError;
class InjectedConnector extends abstract_connector_1.AbstractConnector {
    constructor(chainId) {
        super({
            supportedChainIds: [chainId]
        });
    }
    activate() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!(yield this.isAuthorized())) {
                throw new NoTronWebProviderError();
            }
            let response = yield ((_a = window.tronLink) === null || _a === void 0 ? void 0 : _a.request({
                method: 'tron_requestAccounts'
            }));
            if ((response === null || response === void 0 ? void 0 : response.code) === 4001) {
                throw new UserRejectedRequestError();
            }
            let account = window.tronWeb.defaultAddress.base58;
            return Object.assign({ provider: window.tronWeb }, (account ? { account } : {}));
        });
    }
    getProvider() {
        return __awaiter(this, void 0, void 0, function* () {
            return window.tronWeb;
        });
    }
    getChainId() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(yield this.isAuthorized())) {
                throw new NoTronWebProviderError();
            }
            return 1;
        });
    }
    getAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(yield this.isAuthorized())) {
                throw new NoTronWebProviderError();
            }
            return window.tronWeb.defaultAddress.base58;
        });
    }
    deactivate() {
        return;
    }
    isAuthorized() {
        return __awaiter(this, void 0, void 0, function* () {
            if (window.tronWeb === undefined) {
                return false;
            }
            return !!window.tronWeb.defaultAddress.base58;
        });
    }
}
exports.InjectedConnector = InjectedConnector;
//# sourceMappingURL=InjectedConnector.js.map